'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppPushNotificationsState$Askable(ask) {
  this.Lapp_data_AppPushNotificationsState$Askable__f_ask = null;
  this.Lapp_data_AppPushNotificationsState$Askable__f_ask = ask;
}
export { $c_Lapp_data_AppPushNotificationsState$Askable as $c_Lapp_data_AppPushNotificationsState$Askable };
$c_Lapp_data_AppPushNotificationsState$Askable.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppPushNotificationsState$Askable.prototype.constructor = $c_Lapp_data_AppPushNotificationsState$Askable;
/** @constructor */
function $h_Lapp_data_AppPushNotificationsState$Askable() {
}
export { $h_Lapp_data_AppPushNotificationsState$Askable as $h_Lapp_data_AppPushNotificationsState$Askable };
$h_Lapp_data_AppPushNotificationsState$Askable.prototype = $c_Lapp_data_AppPushNotificationsState$Askable.prototype;
$c_Lapp_data_AppPushNotificationsState$Askable.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_AppPushNotificationsState$Askable.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1092378299, true);
});
$c_Lapp_data_AppPushNotificationsState$Askable.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppPushNotificationsState$Askable)) {
    var x = this.Lapp_data_AppPushNotificationsState$Askable__f_ask;
    var x$2 = x$0.Lapp_data_AppPushNotificationsState$Askable__f_ask;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_data_AppPushNotificationsState$Askable.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_AppPushNotificationsState$Askable.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_data_AppPushNotificationsState$Askable.prototype.productPrefix__T = (function() {
  return "Askable";
});
$c_Lapp_data_AppPushNotificationsState$Askable.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_AppPushNotificationsState$Askable__f_ask;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AppPushNotificationsState$Askable.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "ask";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_AppPushNotificationsState$Askable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_AppPushNotificationsState$Askable)));
}
export { $isArrayOf_Lapp_data_AppPushNotificationsState$Askable as $isArrayOf_Lapp_data_AppPushNotificationsState$Askable };
var $d_Lapp_data_AppPushNotificationsState$Askable = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppPushNotificationsState$Askable, "app.data.AppPushNotificationsState$Askable", ({
  Lapp_data_AppPushNotificationsState$Askable: 1,
  Lapp_data_AppPushNotificationsState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_AppPushNotificationsState$Askable as $d_Lapp_data_AppPushNotificationsState$Askable };
//# sourceMappingURL=app.data.-App-Push-Notifications-State$-Askable.js.map
